"use strict"; // Make a parser helper function to simplify calling this
// https://www.npmjs.com/package/google-libphonenumber

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseTel = void 0;

var phoneNumberTypes_1 = require("../constants/phoneNumberTypes");

var PNF = require("google-libphonenumber").PhoneNumberFormat;

var parseTel = function parseTel(inputPhoneNumber, inputRegionCode) {
  var _a; // Not sure if we need to be calling getInstance within the function but w/e


  var phoneNumberUtil = require("google-libphonenumber").PhoneNumberUtil.getInstance(); // Evaluate results off the bat so a dev doesn't have to know which instance has which func


  var inputPhoneNumberCleaned;
  var error = null;
  var formatE164 = null;
  var formatInOriginalFormat = null;
  var formatInternational = null;
  var formatNational = null;
  var formatOutOfCountryCallingNumberUS = null;
  var formatOutOfCountryCallingNumber = null;
  var getCountryCode = null;
  var getNationalNumber = null;
  var getNumberType = null;
  var getNumberTypeEnum = null;
  var getRegionCodeForNumber = null;
  var isValidNumber = null;
  var isValidNumberForRegion = null;
  var phoneNumber = null; // Number Instance Methods

  try {
    // --- clean up non-digits & special characters
    inputPhoneNumberCleaned = inputPhoneNumber.replace(/[^0-9|+]/g, ""); // --- cast w/ lib
    //Note: expects country code prepended with "+" but its own getCountryCode method doesn't include the "+"

    phoneNumber = phoneNumberUtil.parseAndKeepRawInput(inputPhoneNumberCleaned, inputRegionCode);
  } catch (e) {
    error = e;
  }

  if (phoneNumber) {
    //this is annoying because the package expects the "+" in front of the area code in parseAndKeepRawInput
    //but doesn't include it in getCountryCode() by default, so we add it ourselves
    getCountryCode = "+".concat(phoneNumber.getCountryCode());
    getNationalNumber = phoneNumber.getNationalNumber(); // Phone Utils Methods

    formatE164 = phoneNumberUtil.format(phoneNumber, PNF.E164);
    formatInOriginalFormat = phoneNumberUtil.formatInOriginalFormat(phoneNumber);
    formatInternational = phoneNumberUtil.format(phoneNumber, PNF.INTERNATIONAL);
    formatNational = phoneNumberUtil.format(phoneNumber, PNF.NATIONAL);
    formatOutOfCountryCallingNumberUS = phoneNumberUtil.formatOutOfCountryCallingNumber(phoneNumber, "US");

    formatOutOfCountryCallingNumber = function formatOutOfCountryCallingNumber(regionCode) {
      return phoneNumberUtil.formatOutOfCountryCallingNumber(phoneNumber, regionCode);
    };

    getRegionCodeForNumber = phoneNumberUtil.getRegionCodeForNumber(phoneNumber);
    getNumberType = phoneNumberUtil.getNumberType(phoneNumber);
    getNumberTypeEnum = (_a = Object.values(phoneNumberTypes_1.PHONE_NUMBER_TYPES)[getNumberType]) !== null && _a !== void 0 ? _a : phoneNumberTypes_1.PHONE_NUMBER_TYPES.UNKNOWN;
    isValidNumber = phoneNumberUtil.isValidNumber(phoneNumber);
    isValidNumberForRegion = phoneNumberUtil.isValidNumberForRegion(phoneNumber);
  } // Catch all errs so we don't interrupt returning values


  return {
    error: error,
    formatE164: formatE164,
    formatInOriginalFormat: formatInOriginalFormat,
    formatInternational: formatInternational,
    formatNational: formatNational,
    formatOutOfCountryCallingNumberUS: formatOutOfCountryCallingNumberUS,
    formatOutOfCountryCallingNumber: formatOutOfCountryCallingNumber,
    getCountryCode: getCountryCode,
    getNationalNumber: getNationalNumber,
    getNumberType: getNumberType,
    getNumberTypeEnum: getNumberTypeEnum,
    getRegionCodeForNumber: getRegionCodeForNumber,
    inputPhoneNumber: inputPhoneNumber,
    inputPhoneNumberCleaned: inputPhoneNumberCleaned,
    inputRegionCode: inputRegionCode,
    isValidNumber: isValidNumber,
    isValidNumberForRegion: isValidNumberForRegion,
    number: phoneNumber
  };
};

exports.parseTel = parseTel;